// extracted by mini-css-extract-plugin
module.exports = {"benefits-list":"benefits-list_benefits-list__A792V","benefits-list-icon":"benefits-list_benefits-list-icon__SPenP"};